import { SuggestionData } from "@/common/types/highlightTextArea.type";

interface TextWithMentionsProps {
  value: string;
  suggestions: SuggestionData[];
}

const TextWithMentions = ({ value, suggestions }: TextWithMentionsProps) => {
  const mentionRegex = /@[\w.]+/g;
  const parts = value.split(mentionRegex);
  const mentions = value.match(mentionRegex) || [];

  const filteredMentions = mentions.filter(mention => suggestions.some(suggestion => `@${suggestion.value}` === mention))

  return parts.map((part, index) => (
    <span key={index}>
      {part}
      {mentions[index] && (
        <span className={filteredMentions.includes(mentions[index]) ? 'text-[#FC9CE0] highlighted-mention' : ''}>
          {mentions[index]}
        </span>
      )}
    </span>
  ));
}

export default TextWithMentions;
